import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-06-07
 * @brief SEI 체크시트 Management 개발
 *
 ********************************************************************/
import { useState } from "react";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { reloadSpg } from "../../../recoil/userState";
//utils
import * as CUTIL from "../../../utils/commUtils";
import { useOutletContext } from "react-router-dom";
import { checkSheetInfo, checkSheetState } from "../../../recoil/menuState";
import { useTrans } from "../../../utils/langs/useTrans";
import CheckSheetList from "./CheckSheetList";
import CheckSheetTree from "./CheckSheetTree";
import CheckSheetView from "./CheckSheetView";
function CheckSheetMain() {
    const t = useTrans();
    //recoil
    const [checksheet, setCheckSheet] = useRecoilState(checkSheetState);
    const sheetInfo = useRecoilValue(checkSheetInfo);
    const setReloadSpg = useSetRecoilState(reloadSpg);
    //props
    const { handleOpenPop } = useOutletContext();
    const checksheetName = [t("체크시트관리.LS정밀점검"), t("체크시트관리.고객향점검") /* "직무고시 점검" */];
    const [checkSheetItem, setCheckSheetItem] = useState(null);
    const [workMode, setWorkMode] = useState("VIEW");
    function ClickSheet(sheet) {
        if (checksheet.sheetType == sheet) {
            setCheckSheet(Object.assign(Object.assign({}, checksheet), { sheetType: sheet }));
        }
        else {
            setCheckSheet({
                sheetType: sheet,
                spgName: sheet !== checksheetName[1] ? checkSheetItem[sheet][0].name : checkSheetItem[sheet][0].spgName,
            });
        }
    }
    function ClickSpg(item) {
        setCheckSheet(Object.assign(Object.assign({}, checksheet), { spgName: checksheet.sheetType !== checksheetName[1] ? item.name : item.spgName }));
        setReloadSpg(true);
        WorkModes("VIEW");
    }
    function WorkModes(val) {
        setWorkMode(val);
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "box-wrap" }, { children: [_jsx(CheckSheetTree, { checksheetName: checksheetName, checkSheetItem: checkSheetItem, setCheckSheetItem: setCheckSheetItem, handleOpenPop: handleOpenPop, WorkModes: WorkModes }), _jsxs("div", Object.assign({ className: "content-wrap" }, { children: [_jsx("div", Object.assign({ className: "box__header flex-column brd-bottom-0 pb-0" }, { children: _jsxs("div", Object.assign({ className: "flex-inline gap-24" }, { children: [_jsxs("div", Object.assign({ className: "select sheet", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: checksheet.sheetType })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checksheetName.map((sheetName, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => ClickSheet(sheetName) }, { children: sheetName }), "sheetSel_" + idx.toString()))) })] })), _jsxs("div", Object.assign({ className: "select spg", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: checksheet.spgName })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkSheetItem &&
                                                    checkSheetItem[checksheet.sheetType].map((item, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => ClickSpg(item) }, { children: checksheet.sheetType !== "고객향 점검" ? item.name : item.spgName }), "spgSel_" + idx.toString()))) })] }))] })) })), workMode == "VIEW" && checkSheetItem && (_jsx(CheckSheetView, { checksheetName: checksheetName, handleOpenPop: handleOpenPop, WorkModes: WorkModes })), workMode == "LIST" && sheetInfo.checkversionId > 0 && (_jsx(CheckSheetList, { checksheetName: checksheetName, handleOpenPop: handleOpenPop, WorkModes: WorkModes }))] }))] })) }));
}
export default CheckSheetMain;
